import { useEffect, useState } from "react";
import { fetchDefaultRewardRuleAPI, fetchRewardOpenAPI } from "./rewardAPI";

// 출제 창의 '완료 포인트'. 지인에듀 문제지 출제, 문제뱅크 출제, 수학 출제가 함께 쓴다.
// 처음 열 때 학원 관리 > 포인트 에서 정한 이 유형의 기본값('몇 점 이상 몇 P', 처음은 0점 이상 100P)으로 채운다.
// 여기서 바꾼 값은 이번 출제에만 쓰인다(이벤트). 기본값은 바뀌지 않는다.
// 값을 비워 보내도 서버가 같은 기본값을 넣으므로 포인트가 빠지는 출제는 없다.
export const useDefaultRewardPoints = (assignmentType, setRewardPoints, setRewardMinScore) => {
  useEffect(() => {
    if (!assignmentType) return undefined;
    let isCurrent = true;
    fetchDefaultRewardRuleAPI(assignmentType)
      .then((rule) => {
        if (!isCurrent) return;
        setRewardPoints(rule.reward_points);
        if (setRewardMinScore) setRewardMinScore(rule.min_score);
      })
      .catch(() => {});
    return () => {
      isCurrent = false;
    };
  }, [assignmentType, setRewardPoints, setRewardMinScore]);
};

// 상점을 켜지 않은 학원(기프티쇼 키 + 활성화 체크 전)에는 칸을 띄우지 않는다. 서버도 그런 학원에는 포인트를 쌓지 않는다.
const numberInputStyle = {
  width: "70px",
  padding: "7px 10px",
  border: "1.5px solid #D6DEE0",
  borderRadius: "9px",
  fontSize: "0.95rem",
  fontWeight: 800,
  textAlign: "right",
};

const toNumberOrEmpty = (text, max) => (text === "" ? "" : Math.min(max, Math.max(0, Number(text))));

const RewardPointsField = ({ value, onChange, minScore, onMinScoreChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    let isCurrent = true;
    fetchRewardOpenAPI().then((open) => isCurrent && setIsOpen(open));
    return () => {
      isCurrent = false;
    };
  }, []);
  if (!isOpen) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "13px 16px",
        backgroundColor: "#F4F8F7",
        borderRadius: "13px",
      }}
    >
      <div
        style={{
          flex: 1,
          fontSize: "0.86rem",
          fontWeight: 800,
          color: "#0E141B",
          letterSpacing: "-0.01em",
        }}
      >
        완료 포인트
      </div>
      {onMinScoreChange && (
        <>
          <input
            type="number"
            min={0}
            max={100}
            step={10}
            inputMode="numeric"
            value={minScore ?? ""}
            onChange={(event) => onMinScoreChange(toNumberOrEmpty(event.target.value, 100))}
            style={numberInputStyle}
          />
          <span style={{ fontWeight: 800, color: "#0E141B", whiteSpace: "nowrap" }}>점 이상</span>
        </>
      )}
      <input
        type="number"
        min={0}
        step={10}
        inputMode="numeric"
        value={value ?? ""}
        onChange={(event) => onChange(toNumberOrEmpty(event.target.value, 100000))}
        style={{ ...numberInputStyle, width: "90px" }}
      />
      <span style={{ fontWeight: 800, color: "#0E141B" }}>P</span>
    </div>
  );
};

export default RewardPointsField;
